module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAR5JREFUeNrcVNENgjAQLcZ/GaFu4AiMwAgwAfrBN/DNBzABbCBu4AY6giOwgb4zp2lIlWIhUS9prlzae8e71xPi183pB+I4TuESg7tNnufh0KGFJpYYFhegmPoTgDE2CLKYgOa3IKYAZ6wMq8S6jAHRNfmqfHZYIZrZ9s5s4QqTxi8HKr8nR0If+4gBK8RKxFyNIAK6YwpwVpLvlbiP2JrpSmxUdGAf6TgHOP3N0QZgpfShb52pxN4B+OwrTfIGNEl4zwZAklpABdGwZpnuaM/0bGz/gKzg2dQhaUrqwd6lxrN0w0+G3fXF2UdDPUXCRBVJ8/nIEHPGvAPV+nzXSE6+ZbnKOWYRVX56lXyqYSfnnqbi6wAyi3yZ+Du7CTAAtGhgBoFKBcUAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/images/bill-view.png
// module id = 608
// module chunks = 0